import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errorMessage } from "../lib/api";
import { AuthLayout } from "./Login";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setResult(data);
    } catch (err) {
      toast.error(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Reset your password" subtitle="Enter your email and we'll send you a secure reset link.">
      {result ? (
        <div className="space-y-4" data-testid="forgot-password-result">
          <p className="text-sm text-slate-700 bg-emerald-50 border border-emerald-200 rounded-md p-4">{result.message}</p>
          {result.reset_url && (
            <div className="text-sm bg-amber-50 border border-amber-200 rounded-md p-4 space-y-2">
              <p className="font-medium text-amber-900">Development mode: reset link</p>
              <a href={result.reset_url} className="break-all text-emerald-700 underline" data-testid="reset-link">{result.reset_url}</a>
            </div>
          )}
          <Link to="/login" className="text-sm text-emerald-700 hover:underline" data-testid="back-to-login-link">Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-password-form">
          <div className="space-y-1.5"><Label>Email</Label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" className="h-11" /></div>
          <Button type="submit" disabled={busy} className="w-full h-11 bg-slate-900 hover:bg-slate-800" data-testid="forgot-submit-button">{busy ? "Sending…" : "Send reset link"}</Button>
          <Link to="/login" className="block text-sm text-emerald-700 hover:underline" data-testid="back-to-login-link">Back to sign in</Link>
        </form>
      )}
    </AuthLayout>
  );
}
